import template from "./choices-select.html";
import "./choices-select.less";

// selection
export class Controller {
	constructor($logger) {
		this.$logger = $logger;
	}

	$onInit() {
	}

	setChoicesBox(box) {
		this.box = box;

		return this.setBox({ box: this });
	}

	enable() {
		return this.box.enable();
	}

	disable() {
		this.box.hideDropdown();
		return this.box.disable();
	}

	getValue(boolVal) {
		return this.box.getValue(boolVal);
	}

	removeItemsByValue(values) {
		if(values === this.selectModel) {
			this.selectModel = undefined;
		}

		return this.box.removeItemsByValue(values);
	}

	setChoices(choice, valStr, labelStr, boolVal) {
		return this.box.setChoices(choice, valStr, labelStr, boolVal);
	}

	setValueByChoice(strVal) {
		return this.box.setValueByChoice(strVal);
	}

	clearStore() {
		return this.box.clearStore();
	}

	setChoicesDisplay(id) {
		return this.setDisplay({ value: id });
	}

	handleChoicesValueChanged() {
		const modelVal = this.selectModel;
		return this.handleValueChanged({ value: modelVal });
	}

	clearSelected() {
		this.box.removeActiveItems();
	}
}

export default angular
	.module("vesl.components.report-form.choices-select", [])
	.component("choicesSelect", {
		template,
		controller: Controller,
		bindings: {
			focusChoice: "<",
			setDisplay: "&",
			setBox: "&",
			handleValueChanged: "&",
			selectId: "<",
			label: "<",
			search: "<",
			searchFields: "<",
			fuseOptions: "<",
			searchResultLimit: "<",
			renderChoiceLimit: "<",
			isReadonly: "<",
			suppressClear: "<?",
			selectModel: "="
		}
	}).name;
